export enum ProductUnitCodeTypeGroup {
  Ean = 1,
  WeighingGoods = 2,
  SupplierCode = 3,
  InternalCode = 4,
}

(ProductUnitCodeTypeGroup as any).__typeName = 'ProductUnitCodeTypeGroup';